import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useStore } from 'vuex'

const DEFAULT_CROSS_INDEX_RETROACTIVE = 'default_cross_index_retroactive'
// TODO: Also temporarily disable requirePerms and work filtering for certain particular orgs until we resolve query branch explosion.
// TODO: Probably need to wait until we upgrade our backend to using native IN queries.
const DISABLE_COSTING_PERMS_ORG_IDS_SETTING_KEY = 'disable_costing_perms'
const DISABLE_COSTING_WORK_LABEL_PERMS_SETTING_KEY = 'disable_costing_work_label_perms'

export function getDefaultCrossIndexRetroactive () {
  const value = localStorage.getItem(DEFAULT_CROSS_INDEX_RETROACTIVE)
  return value ? value === 'true' : undefined
}

export function getDisableCostingPermsSettingValue () {
  const value = localStorage.getItem(DISABLE_COSTING_PERMS_ORG_IDS_SETTING_KEY)
  return value ? value === 'true' : undefined
}

export function getDisableCostingWorkLabelPermsSettingValue () {
  const value = localStorage.getItem(DISABLE_COSTING_WORK_LABEL_PERMS_SETTING_KEY)
  return value ? value === 'true' : undefined
}

// TODO: Also temporarily disable requirePerms and work filtering for certain particular orgs until we resolve query branch explosion.
// TODO: Probably need to wait until we upgrade our backend to using native IN queries.
const DISABLE_COSTING_PERMS_ORG_IDS = [5544977541234688, 5828268817121280, 5835648569180160]
const DISABLE_COSTING_WORK_LABEL_PERMS_ORG_IDS = [5544977541234688, 5828268817121280]

export const useLocalSettingsStore = defineStore('localSettings', () => {
  const store = useStore()

  const orgDisableCostingPermsDefault = DISABLE_COSTING_PERMS_ORG_IDS.includes(store.state.organizationId)
  const orgDisableCostingWorkLabelPermsDefault = DISABLE_COSTING_WORK_LABEL_PERMS_ORG_IDS.includes(store.state.organizationId)

  const defaultCrossIndexRetroactive = ref(getDefaultCrossIndexRetroactive() ?? true)
  const orgDisableCostingPerms = ref(getDisableCostingPermsSettingValue() ?? orgDisableCostingPermsDefault)
  const orgDisableCostingWorkLabelPerms = ref(getDisableCostingWorkLabelPermsSettingValue() ?? orgDisableCostingWorkLabelPermsDefault)

  watch(
    defaultCrossIndexRetroactive,
    () => {
      localStorage.setItem(DEFAULT_CROSS_INDEX_RETROACTIVE, defaultCrossIndexRetroactive.value.toString())
    }
  )

  watch(
    orgDisableCostingPerms,
    () => {
      localStorage.setItem(DISABLE_COSTING_PERMS_ORG_IDS_SETTING_KEY, orgDisableCostingPerms.value.toString())
    }
  )

  watch(
    orgDisableCostingWorkLabelPerms,
    () => {
      localStorage.setItem(DISABLE_COSTING_WORK_LABEL_PERMS_SETTING_KEY, orgDisableCostingWorkLabelPerms.value.toString())
    }
  )

  return {
    defaultCrossIndexRetroactive,
    orgDisableCostingPerms,
    orgDisableCostingWorkLabelPerms
  }
})
